import { takeLatest } from "redux-saga/effects";
import { getStatisticsCommonSaga } from "redux/statistics/sagas/getStatisticsCommonSaga";
import { getStatisticsCommon } from "redux/statistics/statisticsActions";

export function* statisticsSaga() {
  yield takeLatest(getStatisticsCommon.type, getStatisticsCommonSaga);
}
